document.addEventListener("DOMContentLoaded", function () {
  const copyButtons = document.querySelectorAll(".share-button__copy");
  copyButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const shareSection = button.closest(".share-button");
      const inputField = shareSection.querySelector(".field__input");
      const shareMessage = shareSection.querySelector(".share-button__message");
      const fallback = shareSection.querySelector(".share-button__fallback");

      inputField.select();
      inputField.setSelectionRange(0, 99999);

      navigator.clipboard
        .writeText(inputField.value)
        .then(() => {
          setTimeout(() => {
            shareSection.classList.toggle("clicked");
            fallback.classList.toggle("active");
          }, 500);
          shareMessage.textContent = "URL copied to clipboard!";
          shareMessage.classList.remove("hidden");

          setTimeout(() => {
            shareSection.classList.toggle("clicked");
            fallback.classList.toggle("active");
          }, 4000);
        })
        .catch((err) => {
          console.error("Failed to copy: ", err);
        });
    });
  });
});

const shareButton = document.querySelector(".share-button.sharebutton-mobile");
const shareDialog = document.querySelector(".share-dialog");
const closeButton = document.querySelector(".close-button");
shareButton.addEventListener("click", (event) => {
const shareUrl = shareButton.getAttribute("data-share-url");
console.log(shareUrl);
  if (navigator.share) {
    navigator.share({
        title: "Share",
        url: shareUrl, // Use the dynamic Shopify share URL
      })
      .then(() => {
        console.log("Thanks for sharing!");
      })
      .catch(console.error);
  } else {
    shareDialog.classList.add("is-open");
  }
});

// closeButton.addEventListener("click", (event) => {
//   shareDialog.classList.remove("is-open");
// });
